module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasStockData) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.selectedSellerIdSet.has(String(sa.sellerId))
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.selectedSellerIdSet.has(String(sa.sellerId))) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.mpSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "stock-dashboard"
  }, [_c('div', {
    staticClass: "stock-dashboard-content"
  }, [_c('div', {
    staticClass: "stock-page-header stock-page-header-with-actions"
  }, [_c('div', {
    staticClass: "stock-page-header-text"
  }, [_c('h1', {
    staticClass: "stock-page-title"
  }, [_vm._v("Stock Dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "stock-page-subtitle"
  }, [_vm._v("Monitor FBA & FBM inventory levels across all products")])]), _vm._v(" "), (_vm.hasStockData) ? _c('div', {
    staticClass: "stock-page-header-actions"
  }, [_c('button', {
    staticClass: "stock-thresholds-btn",
    class: {
      open: _vm.thresholdPanelOpen
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleThresholdPanel
    }
  }, [_c('i', {
    staticClass: "setting icon"
  }), _vm._v("\n            Alert Thresholds\n            "), _c('i', {
    staticClass: "angle down icon stock-thresholds-chevron"
  })]), _vm._v(" "), _c('button', {
    staticClass: "stock-export-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n            Export CSV\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.hasStockData && _vm.thresholdPanelOpen && !_vm.thresholdPanelReady) ? _c('div', {
    staticClass: "stock-thresholds-prefetch-bar",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('span', [_vm._v("Loading alert thresholds…")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasStockData && _vm.thresholdPanelOpen),
      expression: "hasStockData && thresholdPanelOpen"
    }],
    class: {
      'stock-thresholds-panel-wrap--prefetch': !_vm.thresholdPanelReady
    }
  }, [_c('StockAlertThresholdsPanel', {
    ref: "thresholdsPanel",
    attrs: {
      "panel-open": _vm.hasStockData && _vm.thresholdPanelOpen,
      "seller-account-id": _vm.thresholdSellerAccountId
    },
    on: {
      "close": _vm.onThresholdClose,
      "saved": _vm.onThresholdSaved,
      "spreadsheet-imported": _vm.onThresholdSaved,
      "thresholds-load-complete": function($event) {
        _vm.thresholdPanelReady = true
      }
    }
  })], 1), _vm._v(" "), _c('StockStatCards', {
    attrs: {
      "stats": _vm.statsData,
      "active-filter": _vm.activeFilter,
      "marketplace-count": _vm.marketplaceCount
    },
    on: {
      "filter-change": _vm.onFilterChange
    }
  }), _vm._v(" "), _c('StockInventoryTable', {
    attrs: {
      "products": _vm.products,
      "sort-key": _vm.tableSortKey,
      "sort-dir": _vm.tableSortDir,
      "search-query": _vm.searchQuery,
      "current-page": _vm.currentPage,
      "total-pages": _vm.totalPages,
      "total-items": _vm.totalItems,
      "pagination-pages": _vm.paginationPages
    },
    on: {
      "sort": _vm.onSort,
      "search": _vm.onSearch,
      "page": _vm.onPage,
      "show-details": _vm.onShowDetails
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5c1d08a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/StockPage.vue
// module id = 807
// module chunks = 2